import type { IKlipyGif, IKlipyMediaFile } from '@/services/media/providers/klipy/types';

export type KlipyPreviewSize = 'sm' | 'md';

export function getKlipyGifPreview(
  gif: IKlipyGif,
  preferredSize: KlipyPreviewSize = 'sm'
): IKlipyMediaFile | undefined {
  const sizes: KlipyPreviewSize[] = preferredSize === 'sm' ? ['sm', 'md'] : ['md', 'sm'];

  for (const size of sizes) {
    const variant = gif.file[size];
    const file = variant?.webp ?? variant?.gif;
    if (file?.url) return file;
  }

  return undefined;
}

export function getKlipyGifAspectRatio(
  gif: IKlipyGif,
  preferredSize: KlipyPreviewSize = 'sm'
): number {
  const preview = getKlipyGifPreview(gif, preferredSize);
  return preview?.width && preview?.height ? preview.width / preview.height : 1;
}

export function dedupeKlipyGifs(gifs: IKlipyGif[]): IKlipyGif[] {
  const seen = new Set<string>();
  return gifs.filter((gif) => {
    if (seen.has(gif.slug)) return false;
    seen.add(gif.slug);
    return true;
  });
}

export function mergeKlipyGifs(existing: IKlipyGif[], incoming: IKlipyGif[]): IKlipyGif[] {
  return dedupeKlipyGifs([...existing, ...incoming]);
}
